"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useId = exports.IdProvider = void 0;
// The `useId` hook isn't availble until React 18,
// and we need to support 17 as well
const react_1 = __importDefault(require("react"));
let idLocal = -1;
const IdContext = react_1.default.createContext({
    getId: () => {
        idLocal = idLocal + 1;
        return `r${idLocal}`;
    }
});
const IdProvider = ({ children }) => {
    const id = react_1.default.useRef(0);
    const getId = react_1.default.useCallback(() => {
        id.current = id.current + 1;
        return `r${id.current}`;
    }, []);
    return react_1.default.createElement(IdContext.Provider, { value: { getId } }, children);
};
exports.IdProvider = IdProvider;
const useId = () => {
    const { getId } = react_1.default.useContext(IdContext);
    const id = react_1.default.useMemo(() => getId(), [getId]);
    return id;
};
exports.useId = useId;
//# sourceMappingURL=useId.js.map